export default __webpack_public_path__ + "static/thebottomline27-01eb6ba5525a5a3935045ded833fbbcf.jpg";